import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {IResourceMethod, ResourceAction, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpinnerHelper } from '../../helpers/spinner/spinner.helper';
import {tap} from 'rxjs/operators';

/**
 Class for the CompanyService.
 */

export interface IGasStation {
    gas_station_cod?: string;
    gas_station_name?: string;
    city_id?: number;
    show_in_app?: number;
}

export interface IGasConvenience {
    store?: number;
    oil_change?: number;
    washing?: number;
    rubber_repair?: number;
    accommodation?: number;
    restaurant?: number;
    hours_services?: number;
    tire_calibrator?: number;
}

export interface IGasLocation {
    lat?: string;
    long?: string;
}

@Injectable()
@ResourceParams({
    url: BaseService.BASE_URL + '/v1/gas-stations'
})
export class GasService extends BaseService {

    @ResourceAction({
        method: ResourceRequestMethod.Post,
    })
    save: IResourceMethod<any, any>;

    @ResourceAction({
        method: ResourceRequestMethod.Put,
        path: '/{!id}'
    })
    update: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/{!id}?expand=merchandise,convenience,location'
    })
    get: IResourceMethod<any, any>;

    @ResourceAction({
        path: '?expand=merchandise,convenience,city.state,location',
        isArray: true
    })
    query: IResourceMethod<any, any[]>;

    @ResourceAction({
        method: ResourceRequestMethod.Delete,
        path: '/{!id}'
    })
    remove: IResourceMethod<{ id: any }, any>;

    @ResourceAction({
        method: ResourceRequestMethod.Post,
        path: '/send-message'
    })
    sendMessage: IResourceMethod<{ id: any, messageType: string }, any>;

    sendMessageToMany(formData: FormData, loadingText: string = ''): Observable<any> {
        const url = `${BaseService.BASE_URL}/v1/gas-stations/send-message-to-many`;

        const userData = this._auth.getUser();
        
        const headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': '',
            'Authorization': `Bearer ${userData.access_token}`,
        });

        SpinnerHelper.displayLoader(true, loadingText);

        return this.http.post(url, formData, { headers }).pipe(
            tap(
                () => SpinnerHelper.displayLoader(false), // Hide the spinner on success
                () => SpinnerHelper.displayLoader(false) // Hide the spinner on error
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/gas-station/client.service.ts